import React, { useContext, useEffect, useState } from 'react'
import './Header.css';
import logo from '../../assets/logo.png'
import { Link } from "react-router-dom";
import UserContext from '../../UserContext';
import user from '../../assets/user.png'
import axios from 'axios';

const Header = () => {
  
  const { authenticated, userInfo } = useContext(UserContext);
  const [userData, setUserData] = useState();
  const [loading, setLoading] = useState(true);
  const [verified,setVerified] = useState();


  useEffect(() => {
    try{
      axios.get(`https://event-finder12.onrender.com/users/getuser/${userInfo.email}`).then((res) => {
        setUserData(res.data);
      });
      
      setVerified(userInfo.emailVerified)
    } catch(err) {
      console.log(err)
    }
   

    setLoading(false);
  }, []);

  return (
    <header>
      <img src={logo} alt="Logo" />
      {loading ? (
        <></>
      ) : (
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
            {!authenticated || !verified ? (
              <li className="header-login"><Link to="/login">Login</Link></li>
            ) : (
              <>
               {userData ? 
    (userData.role === 'customer' && authenticated ? 
        <Link to="/dashboard"><li className="user-icon"><img src={userData.picture || user} alt="User Icon" /></li></Link>
    : userData.role === 'organizer' ?
        <Link to="/admin-dashboard"><li className="user-icon"><img src={userData.picture || user} alt="User Icon" /></li></Link>
    : userData.role === 'siteAdmin' ?
        <Link to="/admin-panel"><li className="user-icon"><img src={userData.picture || user} alt="User Icon" /></li></Link>
    : null)
: null}
              </>
            )}
          </ul>
        </nav>
      )}
    </header>
  );












}

export default Header